var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('Transactions-List',{attrs:{"address":_vm.address,"currentAddress":_vm.address}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }